import { AppProvider } from "./context/context";
import Maps from "./Maps";
import { LicenseTypes, MapPageFor } from "../../../../utils/Enum.types";
export interface NavTypeProps {
  NavType: LicenseTypes;
  pageFor: MapPageFor;
}
const MapsIndex = ({ NavType, pageFor }: NavTypeProps) => {
  return (
    <AppProvider>
      <Maps NavType={NavType} pageFor={pageFor} />
    </AppProvider>
  );
};

export default MapsIndex;
